import { render, staticRenderFns } from "./TrendDetails.vue?vue&type=template&id=967f9866&scoped=true"
import script from "./TrendDetails.vue?vue&type=script&lang=js"
export * from "./TrendDetails.vue?vue&type=script&lang=js"
import style0 from "./TrendDetails.vue?vue&type=style&index=0&id=967f9866&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967f9866",
  null
  
)

export default component.exports